module.exports = __webpack_public_path__ + "static/img/pic8.7a938ca3.png";